import { PAINTING_PLAN_ADMIN_PAGE_PERMISSIONS, PAINTING_PLAN_ALL_PERMISSIONS, canAccessPaintingPlanAdmin, } from './paintingPlanPermissions';
import { canAccessAnyProposalBaseSubTab } from './proposalBaseSheetPermissions';
import { GPTA_FORMULA_PACKS_PAGE_PERMISSIONS, canAccessGptaFormulaPacks, } from './gptaFormulaPackPermissions';
const comercial = (acao) => ({ modulo: 'comercial', acao });
export const ADMIN_CONFIG_PAGE_PERMISSIONS = [
    comercial('visualizar_admin'),
    comercial('editar_admin'),
    comercial('excluir_admin'),
];
export const ADMIN_WRITE_PERMISSIONS = [
    comercial('editar_admin'),
    comercial('excluir_admin'),
];
export const CHECKLISTS_PAGE_PERMISSIONS = [
    comercial('visualizar_checklists'),
    comercial('editar_checklists'),
    comercial('excluir_checklists'),
];
export const CHECKLISTS_WRITE_PERMISSIONS = [
    comercial('editar_checklists'),
    comercial('excluir_checklists'),
];
export const PROPOSAL_MODELS_PAGE_PERMISSIONS = [
    comercial('visualizar_modelos_propostas'),
    comercial('editar_modelos_propostas'),
    comercial('excluir_modelos_propostas'),
];
export const PROPOSAL_MODELS_WRITE_PERMISSIONS = [
    comercial('editar_modelos_propostas'),
    comercial('excluir_modelos_propostas'),
];
export const TASK_REGISTRATIONS_PAGE_PERMISSIONS = [
    comercial('visualizar_cadastros_tarefas'),
    comercial('editar_cadastros_tarefas'),
    comercial('excluir_cadastros_tarefas'),
];
export const TASK_REGISTRATIONS_WRITE_PERMISSIONS = [
    comercial('editar_cadastros_tarefas'),
    comercial('excluir_cadastros_tarefas'),
];
export const PROPOSAL_BASE_PAGE_PERMISSIONS = [
    comercial('visualizar_dados_base_proposta'),
    comercial('editar_dados_base_proposta'),
    comercial('excluir_dados_base_proposta'),
];
export const HEADER_RULES_PAGE_PERMISSIONS = [
    comercial('visualizar_regras_cabecalho'),
    comercial('editar_regras_cabecalho'),
    comercial('excluir_regras_cabecalho'),
];
export const VENDOR_LIST_RULES_PAGE_PERMISSIONS = [
    comercial('visualizar_regras_vendor_list'),
    comercial('editar_regras_vendor_list'),
    comercial('excluir_regras_vendor_list'),
    comercial('editar_dados_base_vendor_list'),
    comercial('editar_dados_base_proposta'),
];
export const VENDOR_LIST_RULES_WRITE_PERMISSIONS = [
    comercial('editar_regras_vendor_list'),
    comercial('editar_dados_base_vendor_list'),
    comercial('editar_dados_base_proposta'),
];
export const PROPOSAL_RULES_PAGE_PERMISSIONS = [
    comercial('visualizar_regras_proposta'),
    comercial('editar_regras_proposta'),
    comercial('excluir_regras_proposta'),
];
export const QUESTIONNAIRES_PAGE_PERMISSIONS = [
    comercial('visualizar_questionarios'),
    comercial('editar_questionarios'),
    comercial('excluir_questionarios'),
    comercial('publicar_questionarios'),
];
export const TASK_RULES_PAGE_PERMISSIONS = [
    comercial('visualizar_regras_tarefas'),
    comercial('editar_regras_tarefas'),
    comercial('excluir_regras_tarefas'),
];
export const PAINTING_PLAN_PAGE_PERMISSIONS = [
    ...PAINTING_PLAN_ALL_PERMISSIONS,
];
export { PAINTING_PLAN_ADMIN_PAGE_PERMISSIONS };
export const PAINTING_PLAN_WRITE_PERMISSIONS = [
    comercial('editar_plano_pintura'),
    comercial('cadastrar_ral_pintura'),
    comercial('cadastrar_padrao_pintura'),
];
export function canAccessPaintingPlan(hasPermission) {
    return canAccessPaintingPlanAdmin(hasPermission);
}
export function canEditPaintingPlan(hasPermission) {
    return hasAnyPermission(hasPermission, PAINTING_PLAN_WRITE_PERMISSIONS);
}
export { GPTA_FORMULA_PACKS_PAGE_PERMISSIONS, canAccessGptaFormulaPacks };
function hasAnyPermission(hasPermission, permissions) {
    return permissions.some(permission => hasPermission(permission.modulo, permission.acao));
}
export function canAccessAdminConfig(hasPermission) {
    return hasAnyPermission(hasPermission, ADMIN_CONFIG_PAGE_PERMISSIONS);
}
export function canAccessChecklists(hasPermission) {
    return hasAnyPermission(hasPermission, CHECKLISTS_PAGE_PERMISSIONS);
}
export function canEditChecklists(hasPermission) {
    return hasPermission('comercial', 'editar_checklists');
}
export function canDeleteChecklists(hasPermission) {
    return hasPermission('comercial', 'excluir_checklists');
}
export function canAccessProposalModels(hasPermission) {
    return hasAnyPermission(hasPermission, PROPOSAL_MODELS_PAGE_PERMISSIONS);
}
export function canEditProposalModels(hasPermission) {
    return hasPermission('comercial', 'editar_modelos_propostas');
}
export function canDeleteProposalModels(hasPermission) {
    return hasPermission('comercial', 'excluir_modelos_propostas');
}
export function canAccessTaskRegistrations(hasPermission) {
    return hasAnyPermission(hasPermission, TASK_REGISTRATIONS_PAGE_PERMISSIONS);
}
export function canEditTaskRegistrations(hasPermission) {
    return hasPermission('comercial', 'editar_cadastros_tarefas');
}
export function canDeleteTaskRegistrations(hasPermission) {
    return hasPermission('comercial', 'excluir_cadastros_tarefas');
}
export function canAccessProposalBase(hasPermission) {
    return (hasAnyPermission(hasPermission, PROPOSAL_BASE_PAGE_PERMISSIONS) ||
        canAccessAnyProposalBaseSubTab(hasPermission));
}
export function canAccessHeaderRules(hasPermission) {
    return hasAnyPermission(hasPermission, HEADER_RULES_PAGE_PERMISSIONS);
}
export function canAccessVendorListRules(hasPermission) {
    return hasAnyPermission(hasPermission, VENDOR_LIST_RULES_PAGE_PERMISSIONS);
}
export function canEditVendorListRules(hasPermission) {
    return hasAnyPermission(hasPermission, VENDOR_LIST_RULES_WRITE_PERMISSIONS);
}
export function canAccessProposalRules(hasPermission) {
    return hasAnyPermission(hasPermission, PROPOSAL_RULES_PAGE_PERMISSIONS);
}
export function canAccessQuestionnaires(hasPermission) {
    return hasAnyPermission(hasPermission, QUESTIONNAIRES_PAGE_PERMISSIONS);
}
export function canAccessTaskRules(hasPermission) {
    return hasAnyPermission(hasPermission, TASK_RULES_PAGE_PERMISSIONS);
}
export const COMERCIAL_ADMIN_AREA_ACCESS_PERMISSIONS = [
    ...ADMIN_CONFIG_PAGE_PERMISSIONS,
    ...CHECKLISTS_PAGE_PERMISSIONS,
    ...PROPOSAL_MODELS_PAGE_PERMISSIONS,
    ...TASK_REGISTRATIONS_PAGE_PERMISSIONS,
    ...PROPOSAL_BASE_PAGE_PERMISSIONS,
    ...HEADER_RULES_PAGE_PERMISSIONS,
    ...VENDOR_LIST_RULES_PAGE_PERMISSIONS,
    ...PROPOSAL_RULES_PAGE_PERMISSIONS,
    ...QUESTIONNAIRES_PAGE_PERMISSIONS,
    ...TASK_RULES_PAGE_PERMISSIONS,
    ...GPTA_FORMULA_PACKS_PAGE_PERMISSIONS,
    ...PAINTING_PLAN_PAGE_PERMISSIONS,
];
export function canAccessAnyComercialAdminArea(hasPermission) {
    return (hasAnyPermission(hasPermission, COMERCIAL_ADMIN_AREA_ACCESS_PERMISSIONS) ||
        canAccessAnyProposalBaseSubTab(hasPermission));
}
export function resolveFirstAccessibleAdminShortcut(hasPermission) {
    return ADMIN_SHORTCUTS.find(shortcut => shortcut.canAccess(hasPermission))?.to ?? null;
}
export const ADMIN_SHORTCUTS = [
    {
        to: '/app/comercial/admin/checklists',
        label: 'Checklists',
        canAccess: canAccessChecklists,
    },
    {
        to: '/app/comercial/admin/modelos/propostas',
        label: 'Modelos de propostas',
        canAccess: canAccessProposalModels,
    },
    {
        to: '/app/comercial/admin/cadastros/tarefas',
        label: 'Cadastros de tarefas',
        canAccess: canAccessTaskRegistrations,
    },
    {
        to: '/app/comercial/admin/regras-cabecalho',
        label: 'Regras de cabeçalho',
        canAccess: canAccessHeaderRules,
    },
    {
        to: '/app/comercial/admin/regras-vendor-list',
        label: 'Regras de VendorList',
        canAccess: canAccessVendorListRules,
    },
    {
        to: '/app/comercial/admin/questionarios',
        label: 'Questionários iniciais',
        canAccess: canAccessQuestionnaires,
    },
    {
        to: '/app/comercial/admin/regras-tarefas',
        label: 'Regras de tarefas',
        canAccess: canAccessTaskRules,
    },
    {
        to: '/app/comercial/admin/dados-base-proposta',
        label: 'Dados base proposta',
        canAccess: canAccessProposalBase,
    },
    {
        to: '/app/comercial/admin/formulas-gpta',
        label: 'Fórmulas GPTA',
        canAccess: canAccessGptaFormulaPacks,
    },
    {
        to: '/app/comercial/admin/plano-pintura/catalogos-tecnicos/tintas-e-ral',
        label: 'Plano de Pintura',
        canAccess: canAccessPaintingPlan,
    },
];
